var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3Plan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#F5D000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 33.5H22.5C20.8431 33.5 19.5 34.8431 19.5 36.5V59.5C19.5 61.1569 20.8431 62.5 22.5 62.5H30.5C32.1569 62.5 33.5 61.1569 33.5 59.5V36.5C33.5 34.8431 32.1569 33.5 30.5 33.5Z",
    stroke: "black",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 40H29.5M23.5 45H29.5M23.5 50H28",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 27.5H40.5C38.8431 27.5 37.5 28.8431 37.5 30.5V59.5C37.5 61.1569 38.8431 62.5 40.5 62.5H48.5C50.1569 62.5 51.5 61.1569 51.5 59.5V30.5C51.5 28.8431 50.1569 27.5 48.5 27.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43.5C46.9853 43.5 49 41.4853 49 39C49 36.5147 46.9853 34.5 44.5 34.5C42.0147 34.5 40 36.5147 40 39C40 41.4853 42.0147 43.5 44.5 43.5Z",
    fill: "#F5D000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2002 38.9999L43.8002 40.5999L47.0002 37.3999",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48H48M41 53H48",
    stroke: "#F5D000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 33.5H58.5C56.8431 33.5 55.5 34.8431 55.5 36.5V59.5C55.5 61.1569 56.8431 62.5 58.5 62.5H66.5C68.1569 62.5 69.5 61.1569 69.5 59.5V36.5C69.5 34.8431 68.1569 33.5 66.5 33.5Z",
    stroke: "black",
    strokeWidth: 2.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 40H65.5M59.5 45H65.5M59.5 50H64",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Plan);
export default __webpack_public_path__ + "static/media/step-3-plan.3abee7c254bdd5b15c29f3a3f07daa7c.svg";
export { ForwardRef as ReactComponent };